import { BaseModel, convertToArrayModels, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ResearchDemandFilter from './ResearchDemandFilter'

export default class ResearchDemandFilters extends BaseModel {
  static override constructorName = 'ResearchDemandFilters'

  list: ResearchDemandFilter[] = []

  constructor(data?: unknown) {
    super(data)

    let rawFilters: unknown = []

    if (Array.isArray(data)) {
      rawFilters = data
    }
    else if (isUnknownObject(data) && Array.isArray(data.data)) {
      rawFilters = data.data
    }

    this.list = convertToArrayModels(rawFilters, ResearchDemandFilter)
  }
}

registerModel(ResearchDemandFilters)
